import { render, staticRenderFns } from "./LargePayoutApprovalStep.vue?vue&type=template&id=e06223c8&scoped=true"
import script from "./LargePayoutApprovalStep.vue?vue&type=script&lang=js"
export * from "./LargePayoutApprovalStep.vue?vue&type=script&lang=js"
import style0 from "./LargePayoutApprovalStep.vue?vue&type=style&index=0&id=e06223c8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e06223c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e06223c8')) {
      api.createRecord('e06223c8', component.options)
    } else {
      api.reload('e06223c8', component.options)
    }
    module.hot.accept("./LargePayoutApprovalStep.vue?vue&type=template&id=e06223c8&scoped=true", function () {
      api.rerender('e06223c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/online-transaction/components/LargePayoutApprovalStep.vue"
export default component.exports